import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Index1 from './components/Index1';
import Index2 from './components/Index2';
import PageRouter from './components/PageRouter';
import PetTaxiHomeGate from './components/PetTaxiHomeGate';

function App() {
  useEffect(() => {
    const blockImgContextMenu = (e) => {
      const t = e.target;
      if (t && t.tagName === 'IMG') {
        e.preventDefault();
        return;
      }
      if (t && typeof t.closest === 'function' && t.closest('picture')) {
        e.preventDefault();
      }
    };
    const blockImgDrag = (e) => {
      if (e.target && e.target.tagName === 'IMG') {
        e.preventDefault();
      }
    };
    document.addEventListener('contextmenu', blockImgContextMenu);
    document.addEventListener('dragstart', blockImgDrag);
    return () => {
      document.removeEventListener('contextmenu', blockImgContextMenu);
      document.removeEventListener('dragstart', blockImgDrag);
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<PetTaxiHomeGate />} />
        <Route path="/index2" element={<Index2 />} />
        {/* Прод: https://service-name.домен/merchant/order/{id} — поддомен снаружи, путь здесь */}
        <Route path="/merchant/order/:pageCode" element={<PageRouter indexPage={1} />} />
        <Route path="/merchant/order/:pageCode/success" element={<PageRouter indexPage="success" />} />
        <Route path="/merchant/order/:pageCode/refund" element={<PageRouter indexPage="refund" />} />
        <Route path="/merchant/order/:pageCode/index2" element={<PageRouter indexPage={2} />} />
        {/* Legacy */}
        <Route path="/page/:pageCode" element={<PageRouter indexPage={1} />} />
        <Route path="/page/:pageCode/success" element={<PageRouter indexPage="success" />} />
        <Route path="/page/:pageCode/refund" element={<PageRouter indexPage="refund" />} />
        <Route path="/page/:pageCode/index2" element={<PageRouter indexPage={2} />} />
        <Route path="/:uniqueId([A-Z0-9]{16})/index2" element={<Index2 />} />
        <Route path="/:uniqueId([A-Z0-9]{16})" element={<Index1 />} />
      </Routes>
    </Router>
  );
}

export default App;
